module.exports = __webpack_public_path__ + "img/byqsb.cb04dd0b.png";